<template>
  <CDeviceComponent isDkbDeviceCenter class="DkbDeviceCenter"/>
</template>

<script>
  import CDeviceComponent from '@/components/Page/CSceneManage/CDeviceComponent';// 设备中心
  let vm

  export default {
    name: 'DkbDeviceCenter',
    components: {
      CDeviceComponent
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss">
.CDeviceComponent.DkbDeviceCenter {
  width: 10.5rem;
  height: 5.38rem;
  background: url('/static/images/dkb/dialog/device_center_bg.png') center no-repeat;
  background-size: 100% 100%;

  .tit {
    padding: 0;
    color: #ffffff;
    background-color: transparent;
  }
  .dkbTit1 {
    width: 1.6rem;
    height: 0.33rem;
    line-height: 0.33rem;
    font-size: 0.14rem;
    text-align: center;
    margin-bottom: 0.07rem;
  }
  .dkbTit2 {
    height: 0.22rem;
    line-height: 0.22rem;
    font-size: 0.16rem;
    margin: 0 0 0.21rem 0;
    .toggIcon{
      .ico{
        font-size: 0.12rem;
      }
      .el-radio-group{
        box-shadow:0 0 0.04rem 0.01rem rgba(0,0,0,.28);
        border-radius: 0.03rem;
        background-color: #1F4E78;
      }
      .el-radio-button--small .el-radio-button__inner{
        padding: 0.08rem 0.16rem;
        background-color: transparent;
        border: none;
        color: #fff;
      }
      .el-radio-button.is-active{
        box-shadow: 0 0.02rem 0.04rem 0.01rem rgba(0,0,0,.2);
        
      }
      .el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background-color: #fff;
        color: #666;
      }
    }
  }
  // tabs栏无数据
  .no-device{
    text-align: center;
    font-size: 0.18rem !important;
    color: #18728e;
  }
  .tabsBox .no-device{
    height: 1.16rem;
    line-height: 1.16rem;
  }
  .swiper-container {
    width: 100%;
    height: 1.16rem;
    .swiper-pagination-bullet {
      background: #e5e5e5;
      &.swiper-pagination-bullet-active {
        background: #34e4fd;
      }
    }
  }
  .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 0.06rem;
  }
  .swiper-slide{
    height: 1.16rem;
    width: 100% !important;
    .item{
      width: 0.98rem;
      margin: 0 0.1rem;
      .img{
        width: 0.6rem;
        height:0.6rem;
        border-radius: 50%;
        background-color: transparent;
        img {
          width: inherit;
          height: inherit;
        }
      }
      .name{
        margin-top: 0.1rem;
        font-size: 0.14rem;
        color: #e5e5e5;
      }
      &.active{
        .img{
          box-shadow: none;
          background-color: transparent;
        }
        .name{
          color: #34e4fd;
        }
      }
    }
  }
  // 设备列表
  .dcDkbScroll {
    width: 10.48rem;
    height: 3.8rem;
    padding: 0.2rem 0.3rem;
    overflow-x: auto;
    overflow-y: scroll;
    position: relative;
  }
  .listCont{
    .listTable{
      background: none;
      position: relative;
      height: 2.97rem;
      .paging{
        margin: 0;
        padding: 0;
        position: absolute;
        left: 0;
        bottom: -0.1rem;
        .el-pagination{
          color: #B3B3B3;
          .el-pagination__jump{
            margin-left: 0.15rem;
            color: #fff;
          }
          .el-input__inner{
            background: none;
            border: 0.01rem solid #fff;
            border-radius: 0.03rem;
            height: 0.21rem;
            color: #fff;
            width: 0.4rem;
          }
          .btn-next,.btn-prev{
            background: none;
            color: #fff;
          }
          button:disabled{
            color: #B3B3B3;
          }
          .el-pager li{
            background: none;
            font-size: 0.12rem;
            min-width: 0.2rem;
            &.active{
              color: #fff;
            }
          }
        }
        
      }
      .el-table{
        font-size: 0.12rem;
        background: none;
        &::before{
          height: 0;
        }
        &.el-table--enable-row-hover .el-table__body tr:hover>td{
          background: none;
        }
        .cell{
          line-height: 1;
          padding: 0 0.1rem;
          // text-overflow: ellipsis;
          // overflow: hidden;
          // white-space: nowrap;
        }
        tr{
          background: #072C4E;
          &:nth-child(odd){
            background:#103C5D;
          }
        }
        th{
          padding:0;
          color: #fff;
          background: #072C4E !important;
          border-bottom: none;
          height: 0.33rem;
          .cell{
            display: block;
          }
        }
        td{
          padding:0;
          color: #92A2B1;
          border-bottom: none;
          height: 0.26rem;
          .el-switch{
            height: 0.13rem;
            line-height: 0.13rem;
            font-size: 0.12rem;
          }
          .el-switch__label--left,.el-switch__label--right{
            display: none;
          }
          .el-switch__core{
            width: 0.28rem !important;
            height: 0.13rem;
            &::after{
              width: 0.13rem;
              height: 0.13rem;
              margin-left: 0;
            }
          }
          .is-checked{
            .el-switch__core::after{
              width: 0.13rem;
              height: 0.13rem;
              margin-left: -0.13rem;
              
            }
          }
          .el-button--mini{
            padding: 0.02rem 0.08rem;
            border: 0.01rem solid #15A8BD;
            color: #15A8BD;
            background: none;
            font-size: 0.12rem;
            &.el-button.is-disabled{
              border: 0.01rem solid #2B688E;
              color: #2B688E;
            }
          }
        }
      }
      .ellipsis{
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .status{
        flex-shrink: 0;
        height: 1;
        line-height: 1;
        font-size: 0.12rem;
        padding: 0;
        border-radius: 0;
        color: #EA5413;
        background: none;
        &.onLine{
          background: none;
          color: #98C731;
        }
      }
    }
    .contBtn  {
      position: absolute;
      right: 1.34rem;
      top: 0.15rem;
      .el-button { // 看板通用按钮样式
        width: 0.8rem;
        height: 0.32rem;
        padding: 0;
        line-height: 0.28rem;
        font-size: 0.12rem;
        color: #ffffff;
        border-radius: 0.03rem;
        border: 0.02rem solid rgba(167, 214, 255, 0.73);
        background-color: transparent;
        box-shadow: inset 0 0 0.19rem rgba(140,199,252,0.16);
        -webkit-box-shadow: inset 0 0 0.19rem rgba(140,199,252,0.16);
      }
    }
    .list{
      // padding: 0 0.5rem;
      padding-left: 0.2rem;
    }
    .li:nth-child(4n) {
      margin-right: 0;
    }
    .li{
      flex-shrink: 0;
      min-width: 2rem;
      width: 2rem;
      height: 1.22rem;
      margin-right: 0.5rem;
      margin-bottom: 0.33rem;
      font-size: 18px;
      border: 0.02rem solid #7ca8cf;
      border-radius: 0.06rem;
      box-shadow: 0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
      padding: 0.12rem 0.05rem 0.16rem 0.11rem;
      color: #cccccc;
      background-color: transparent;
      flex-direction: column;
      .ewm{
        width: 0.21rem;
        height: 0.2rem;
        background: url('/static/images/dkb/dialog/icon_ewm.png') no-repeat;
        background-size: 100% 100%;
        &:hover{
          background: url('/static/images/dkb/dialog/icon_ewm1.png') no-repeat;
        }
      }
      .liCont{
        width: 100%;
        max-width: 100%;
        position: relative;
        .bot {
          position: absolute;
          right: 0;
          bottom: 0;
          .detail+.detail {
            margin-left: 0.2rem;
          }
        }
        .detail{
          font-size: 0.12rem;
          color: #71f8f6;
        }
        .name{
          margin-bottom: 0.06rem;
          color: #ffffff;
          padding-right: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            max-width: 1.3rem;
            font-size: 0.16rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .status{
            flex-shrink: 0;
            padding: 0 0.05rem;
            // width: 0.3rem;
            height: 0.22rem;
            line-height: 0.22rem;
            margin-top: 0;
            margin-right: 0.07rem;
            font-size: 0.12rem;
            text-align: center;
            border-radius: 0.03rem;
            background: #ea5413;
            position: static;
            &.onLine{
              background: #81d742;
            }
          }
        }
        .tip {
          max-width: 1.3rem;
          font-size: 0.12rem;
        }
      }
      .liRight {
        width: 1.42rem;
        height: 0.25rem;
        right: 0;
        left: 0;
        bottom: 0.17rem;
        margin: auto;
        .btn {
          width: inherit;
          height: inherit;
          padding: 0;
          color: #1c5a93;
          border-color: #1c5a93;
          border-radius: 0.25rem;
          background-color: transparent;
          &.restart{
            color: #64ceee;
            border-color: #64ceee;
          }
          em{
            display: inline-block;
            height: 20px;
            line-height: 20px;
            border-radius: 3px;
            font-size: 12px;
            color: #fff;
            padding: 0 14px;
            background-color: #008cff;
            cursor: pointer;
            &.noBtn{
              background-color: #999;
            }
          }
        }
      }
      .time{
        position: absolute;
        right: 0;
        left: 0.11rem;
        bottom: 0.4rem;
        font-size: 0.12rem;
        color: #999;
      }
    }
    .no-device {
      color: #cccccc;
      text-align: center;
      line-height: 150px;
    }
  }
}

// 弹窗
.DkbInnerDialog.DkbDeviceCenter {
  > .el-dialog {
    width: 5.74rem !important;
    .el-dialog__body {
      padding: 0 0.23rem 0.4rem;
    }
    // 公共
    .tit_dio {
        width: 100%;
        padding-left: 0.18rem;
        margin: 0.12rem 0 0.25rem;
        color: #ffffff;
        font-size: 0.14rem;
        line-height: 0.2rem;
        display: flex;
        .flexItem {
          margin-right: 0.45rem;
        }
    }
    // 搜索框
    .search_dio {
      width: 100%;
      margin: 0.22rem 0 0.3rem;
      display: flex;
      align-items: center;
      .text{
        width: 1.65rem;
        &+.text {
          margin-left: 0.25rem;
        }
        &.el-select{
          .el-input__suffix {
            right: 0.1rem;
            .el-input__icon {
              width: 0.12rem;
              font-size: 0.12rem;
              line-height: 0.32rem;
              color: #a6aeb8;
            }
          }
        }
        &.datePicker {
          height: 0.32rem;
          background-color: #274663;
          border: none;
          padding-top: 0;
          padding-bottom: 0;
          input {
            // margin-left: 0;
            padding-left: 0;
          }
          .el-range-separator{
            color: #a6aeb8;
            font-size: 0.14rem;
          }
        }
        input {
          padding: 0 0 0 0.2rem;
          height: 0.32rem;
          line-height: 0.3rem;
          border: none;
          color: #a6aeb8;
          font-size: 0.12rem;
          background-color: #274663;
        }
      }
      .dateText {
        margin-left: 0.25rem;
      }
      .serchBtn {
        width: 0.64rem;
        height: 0.32rem;
        padding: 0;
        margin-left: 0.3rem;
        line-height: 0.32rem;
        font-size: 0.12rem;
        border: none;
        color: #34e4fd;
        background-color: #1f4e78;
      }
      .btnSetting { // 看板通用按钮样式
        width: 0.8rem;
        height: 0.32rem;
        padding: 0;
        margin-left: 0.3rem;
        line-height: 0.28rem;
        font-size: 0.12rem;
        color: #ffffff;
        border-radius: 0.03rem;
        border: 0.02rem solid rgba(167, 214, 255, 0.73);
        background-color: transparent;
        box-shadow: inset 0 0 0.19rem rgba(140,199,252,0.16);
        -webkit-box-shadow: inset 0 0 0.19rem rgba(140,199,252,0.16);
      }
    }
    // 带表格的列表
    .contDio.tableWrapper {
      .el-table {
        color: #ffffff;
        background-color: transparent;
        &::before{
          height: 0;
        }
        th, tr {
          padding: 0;
          height: 0.39rem;
          line-height: 0.39rem;
          background-color: transparent;
        }
        td, th, th.is-leaf {
          border-width: 0.02rem;
          border-color: #38527c;
        }
        th.is-leaf {
          color: #c8c8c8;
        }
        tr:hover>td { 
          background-color: transparent!important
        }
        el-table__row>td {
          border: none;
        }
        .el-table__empty-block{
          border-bottom: 0.02rem solid #38527c;
        }
      }
    }
    // 表格斑马纹
    .el-table.DkbStripe {
      font-size: 0.12rem;
        background: none;
        &::before{
          height: 0;
        }
        &.el-table--enable-row-hover .el-table__body tr:hover>td{
          background: none;
        }
        .cell{
          line-height: 1;
          padding: 0 0.1rem;
          // text-overflow: ellipsis;
          // overflow: hidden;
          // white-space: nowrap;
        }
        tr{
          background: #072C4E;
          &:nth-child(odd){
            background:#103C5D;
          }
        }
        th{
          padding:0;
          color: #fff;
          background: #072C4E !important;
          border-bottom: none;
          height: 0.33rem;
          .cell{
            display: block;
          }
        }
        td{
          padding:0;
          color: #92A2B1;
          border-bottom: none;
          height: 0.26rem;
          .el-switch{
            height: 0.13rem;
            line-height: 0.13rem;
            font-size: 0.12rem;
          }
          .el-switch__label--left,.el-switch__label--right{
            display: none;
          }
          .el-switch__core{
            width: 0.28rem !important;
            height: 0.13rem;
            &::after{
              width: 0.13rem;
              height: 0.13rem;
              margin-left: 0;
            }
          }
          .is-checked{
            .el-switch__core::after{
              width: 0.13rem;
              height: 0.13rem;
              margin-left: -0.13rem;
              
            }
          }
          .el-button--mini{
            padding: 0.02rem 0.08rem;
            border: 0.01rem solid #15A8BD;
            color: #15A8BD;
            background: none;
            font-size: 0.12rem;
            &.el-button.is-disabled{
              border: 0.01rem solid #2B688E;
              color: #2B688E;
            }
          }
        }
    }
    // 箱格二维码列表
    .contDio.boxCodeList {
      .explain {
        display: flex;
        align-items: center;
        .text {
          color: #cccccc;
          font-size: 0.14rem;
          margin-left: 0.15rem;
        }
      }
    }
  }
  // 查看箱格
  &.detail1 > .el-dialog {
    width: 8.7rem !important;
    .el-dialog__body {
      padding: 0;
      position: relative;
    }
    // 查看箱格
    .contDio.viewBox {
      padding-top: 0.72rem;
      margin-top: 0.1rem;
      height: 4.25rem;
      overflow-x: hidden;
      overflow-y: scroll;
      .tit_dio {
        width: 8.5rem;
        margin: 0 0 0.1rem;
        padding: 0.27rem 0 0.15rem 0.28rem;
        background-color: #18376a;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
      }
      .list_dio {
        padding: 0 0.28rem;
        .el-row {
          margin: 0 !important;
        }
        .el-col {
          width: 1.35rem;
          height: 1.37rem;
          margin-right: 0.3rem;
          margin-bottom: 0.44rem;
          border-radius: 0.05rem;
          border: 0.01rem solid #80abd7;
          box-shadow: 0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
          &:nth-child(5n) {
            margin-right: 0;
          }
          .colItem{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .status{
              width: 0.44rem;
              height: 0.44rem;
              line-height: 0.44rem;
              border-radius: 50%;
              color: #ffffff;
              background-color: #69ad36;
              font-size: 0.12rem;
              text-align: center;
              &.isIng {
                background-color: #ee6a31;
              }
              &.isNo {
                color: #cccccc;
                background-color: #284d8b;
              }
            }
            .des {
              margin: 0.08rem 0 0.17rem;
              font-size: 0.12rem;
              line-height: 0.16rem;
              color: #ffffff;
              .openStatus {
                color: #cccccc;
              }
            }
            .btn {
              width: 0.85rem;
              height: 0.25rem;
              line-height: 0.25rem;
              border-radius: 0.1rem;
              text-align: center;
              box-sizing: border-box;
              color: #51c1e1;
              border: 0.01rem solid #51c1e1;
              &.no{
                color: #1c5a93;
                border-color: #1c5a93;
              }
              em{
                display: inline-block;
                width: inherit;
                height: inherit;
                font-size: 12px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
  // 查看水电表数据、温湿度采集器详情
  &.detail3 > .el-dialog {
    width: 6.9rem !important;
    .el-dialog__body {
      padding: 0.4rem 0.28rem 0.35rem;
    }
    .contDio {
      width: 100%;
      .meterList {
        width: 100%;
        border: 0.02rem solid #80abd7;
        box-shadow: 0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
      }
      // 水电表详情
      .meterList{
        display: flex;
        width: 100%;
        .echartsDiv{
          flex-grow: 1;
          position: relative;
          .markArea {
            width: 3.4rem;
            display: flex;
            justify-content: center;
            position: absolute;
            bottom: 0.1rem;
            left: 0.4rem;
            .mark {
              color: #ffffff;
              font-size: 0.12rem;
              position: relative;
              &::before{
                display: block;
                content: '';
                width: 0.13rem;
                height: 0.01rem;
                background-color: #40d6e7;
                position: absolute;
                left: -0.16rem;
                top: 0;
                bottom: 0;
                margin: auto;
              }
              &::after{
                display: block;
                content: '';
                width: 0.07rem;
                height: 0.07rem;
                background-color: #18376a;
                border-radius: 50%;
                border: 0.01rem solid #40d6e7;
                box-sizing: border-box;
                position: absolute;
                left: -0.13rem;
                top: 0;
                bottom: 0;
                margin: auto;
              }
            }
          }
          .time{
            text-align: center;
            position: absolute;
            right: 0.13rem;
            top: 0.25rem;
            z-index: 9999;
            .el-radio__input{
              display: none;
            }
            .el-radio{
              width: 0.4rem;
              height: 0.18rem;
              line-height: 0.16rem;
              padding: 0;
              text-align: center;
              margin-right: 16px;
              &.is-bordered {
                color: #04cdf4;
                border-color: #04cdf4;
              }
              &.is-bordered+.el-radio.is-bordered{
                margin-left: 0px;
              }
              &.is-bordered.is-checked {
                color: #18386b;
                background-color: #04cdf4;
              }
              .el-radio__label {
                padding-left: 0;
                font-size: 0.12rem;
              }
            }
          }
          .echart{
            height: 100%;
          }
        }
        .meterStatus{
          width: 1.5rem;
          padding: 0.2rem 0.22rem 0.05rem;
          border-right: 0.02rem solid #dcdcdc;
          box-sizing: border-box;
          .item_meter{
            margin-bottom: 0.2rem; 
            span{
              font-size: 0.12rem;
              line-height: 0.2rem;
              color: #b2b2b2;
            }
            p{
              font-size: 0.14rem;
              line-height: 0.2rem;
              color: #fdfeff;
            }
          }
        }
      }
    }
  }
  // 设备二维码
  &.qrCodeBox > .el-dialog {
    width: 4.12rem !important;
    .el-dialog__header{
      background-color: #18376a;
    }
    .el-dialog__body {
      padding-bottom: 1.1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .img {
        img {
          width: 1.6rem;
          height: 1.6rem;
          border-radius: 0.04rem;
        }
      }
      .tips {
        margin-top: 0.1rem;
        font-size: 0.14rem;
        line-height: 0.2rem;
        text-align: center;
      }
      .tr {
        width: 1.35rem;
        position: absolute;
        bottom: 0.48rem;
        left: 0;
        right: 0;
        margin: auto;
        .el-button {
          width: 100%;
          height: 0.3rem;
          line-height: 0.3rem;
          border-radius: 0.3rem;
          padding: 0;
          box-sizing: border-box;
          border: 0.01rem solid #64ceee;
          color: #64ceee;
          background-color: transparent;
        }
      }
    }
  }
  // 温湿度采集器-预警情况
  &.EPSENSORWarningDio > .el-dialog {
    width: 9.8rem !important;
    .search_dio {
      .text:first-child {
        width: 2.8rem;
      }
    }
  }
  // 温湿度采集器-预警情况-预警设置
  &.EPSENSORsettingDio > .el-dialog {
    width: 6.8rem !important;
    .row {
      margin-bottom: 0.17rem;
      &.T {
        margin-top: 0.36rem;
        .rowTit {
          color: #d65121;
        }
      }
      &.H {
        .rowTit {
          color: #1993d9;
        }
      }
      .rowTit {
        font-size: 0.18rem;
        line-height: 1;
        font-weight: bold;
      }
    }
    .el-form-item{
      margin-bottom: 0;
      display: flex;
      .el-form-item__label {
        flex-shrink: 0;
        color: #ffffff;
        font-size: 0.12rem;
        height: 0.3rem;
        line-height: 0.3rem;
      }
      .el-form-item__content {
        margin-left: 0 !important;
        input {
          width: 1.3rem;
          height: 0.3rem;
          line-height: 0.3rem;
          border-radius: 0;
          background-color: transparent;
          color: #ffffff;
          margin-right: 0.1rem;
        }
        .el-input-group__append {
          background-color: transparent;
          border: none;
          padding: 0;
        }
      }
    }
    .itemRow {
      margin-bottom: 0.56rem;
      display: flex;
      justify-content: space-between;
      .el-form-item {
        width: 47%;
      }
    }
    .btnRow {
      margin-top: 0.16rem;
      display: flex;
      justify-content: flex-end;
      .el-button {
        width: 0.87rem;
        height: 0.37rem;
        line-height: 0.37rem;
        font-size: 0.14rem;
        padding: 0;
        color: #ffffff;
        background-color: #26467d;
        border-color: #7ca8cf;
        &.el-button--primary{
          color: #072c4e;
          background-color: #ffffff;
          border-color: #ffffff;
        }
      }
    }
  }
  // 消毒一体机-设置模式
  &.THAIOSetDio > .el-dialog {
    width: 3.4rem !important;
    .el-dialog__body {
      padding: 0 0.2rem 0.42rem;
    }
    .btnArea {
      display: flex;
      flex-wrap: wrap;

    }
    .btn {
      width: 0.8rem;
      padding: 0;
      margin-right: 0.3rem;
      margin-top: 0.2rem;
      line-height: 0.35rem;
      font-size: 0.12rem;
      text-align: center;
      color: #ffffff;
      background-color: #26467d;
      border-radius: 0.05rem;
      border: 0.01rem solid #7ca8cf;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &.active {
        background-color: #ffffff;
        border-color: #ffffff;
        color: #072c4e;
      }
    }
  }
  // 消毒一体机-操作记录
  &.THAIORecordDio > .el-dialog {
    width: 9.82rem !important;
    .search_dio {
      margin-bottom: 0.2rem;
      .text {
        width: 2.2rem;
        &.datePicker {
          width: 2.6rem;
        }
      }
    }
    .exportBtn { // 看板通用按钮样式
      margin-bottom: 0.3rem;
      width: 0.8rem;
      height: 0.32rem;
      padding: 0;
      line-height: 0.28rem;
      font-size: 0.12rem;
      color: #ffffff;
      border-radius: 0.03rem;
      border: 0.02rem solid rgba(167, 214, 255, 0.73);
      background-color: transparent;
      box-shadow: inset 0 0 0.19rem rgba(140,199,252,0.16);
      -webkit-box-shadow: inset 0 0 0.19rem rgba(140,199,252,0.16);
    }
  }
  // 漏水传感器
  &.WATERLEAKAGECofDio > .el-dialog {
    width: 3.5rem !important;
  }
  //密码保险柜
  &.secrecyDio > .el-dialog {
    .w100{ width: 1rem;}
    .w200{ width: 2rem;}
    .step{
      padding: 0;
      height: 0.3rem;
      margin: 0.2rem 0.33rem 0 0.18rem;
      background: #DADADA;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .item{
        width: 33.33%;
        font-size: 0.12rem;
        color: #fff;
        line-height: 0.3rem;
        text-align: center;
        position: relative;
        &::after{
          content: "";
          position: absolute;
          right: -0.3rem;
          top: 0;
          width: 0;
          height: 0;
          border-width: 0.15rem;
          border-style: solid;
          border-color: transparent transparent transparent #DADADA;
          z-index: 10;
        }
        &.activeStep{
          background: #4BABFE;
          &::after{
            border-color: transparent transparent transparent #4BABFE;
          }
        }
      }
    }
    .SELLBOXSettForm{
      margin-top: 0.2rem;
      .hint{
        margin: 0.1rem 0 0.2rem 0;
        color: #04cdf4;
      }
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label{
          color: #fff;
        }
        .el-form-item__content {
          color: #fff;
        }
      }
      
    }
    .Secrecyform{
      margin-top: 0.2rem;
      .el-form-item{
        margin-bottom: 0.1rem;
        .el-form-item__label{
          line-height: 1;
          padding-bottom: 0.05rem;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/DialogPage/DeviceCenter/DeviceCenter.vue